import { Component, OnInit } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { Button } from 'primeng/button';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { PageProfileDataInterface } from '../../types/performance-profile.type';

@Component({
    selector: 'mon-restore-performance-profile-dialog',
    imports: [
        TranslocoModule,
        Button,
    ],
    templateUrl: './restore-performance-profile-dialog.component.html',
    styleUrls: ['./restore-performance-profile-dialog.component.scss'],
})
export class RestorePerformanceProfileDialogComponent implements OnInit {
    profileData: PageProfileDataInterface | undefined;

    constructor (
        private readonly dialogRef: DynamicDialogRef,
        private readonly dialogConfig: DynamicDialogConfig,
    ) {}

    ngOnInit (): void {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        this.profileData = this.dialogConfig.data;
    }

    cancel (): void {
        this.dialogRef.close(null);
    }

    confirm (): void {
        this.dialogRef.close(true);
    }
}
